import { ArrowNarrowLeftIcon } from "@heroicons/react/outline";
import classNames from "classnames";
import i18n from "i18n";
import Link from "next/link";
import React from "react";

export default function Navigation() {
  return (
    <>
      <div
        className={classNames(
          "fixed flex justify-center h-20 z-10 py-4 px-4 w-full shadow-sm bg-white bg-opacity-50 backdrop-filter backdrop-blur-md transition-all duration-75 delay-100 ease top-0 opacity-100",
        )}
      >
        <div className="flex justify-start items-center max-w-7xl w-full">
          <Link href="/blog">
            <a
              href="/blog"
              className="inline-flex flex-row justify-start font-medium text-gray-900 hover:text-gray-700 transition-all duration-300 ease"
            >
              <ArrowNarrowLeftIcon className="mr-2 -ml-0.5 h-6 w-6" aria-hidden="true" />
              {i18n.t("Back to overview")}
            </a>
          </Link>
        </div>
      </div>
    </>
  );
}
